import { useState, useEffect } from 'react';
import {
  breakpoints,
  getFluidTypography,
  getResponsiveSpacing,
  getAnimationDuration
} from '../utils/responsive';

export const useResponsiveHook = () => {
  const [screenSize, setScreenSize] = useState('lg');

  const getScreenSize = (width) => {
    if (width >= breakpoints['2xl']) return '2xl';
    if (width >= breakpoints.xl) return 'xl';
    if (width >= breakpoints.lg) return 'lg';
    if (width >= breakpoints.md) return 'md';
    if (width >= breakpoints.sm) return 'sm';
    return 'xs';
  };

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(getScreenSize(window.innerWidth));
    };

    // Set initial values
    if (typeof window !== 'undefined') {
      handleResize();
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = screenSize === 'xs' || screenSize === 'sm';
  const isTablet = screenSize === 'md';

  const typography = getFluidTypography(screenSize);
  const spacing = getResponsiveSpacing(screenSize);
  const animationDuration = getAnimationDuration(screenSize);

  // Touch-friendly sizes
  const getTouchTargetSize = () => {
    return isMobile ? 'min-h-[44px] min-w-[44px]' : 'min-h-[40px] min-w-[40px]';
  };

  // Responsive margins and paddings
  const getResponsivePadding = (size = 'default') => {
    const sizes = {
      xs: {
        default: isMobile ? 'p-3' : 'p-4',
        lg: isMobile ? 'p-4' : 'p-6',
        xl: isMobile ? 'p-6' : 'p-8'
      },
      sm: {
        default: 'p-4',
        lg: 'p-6',
        xl: 'p-8'
      },
      md: {
        default: 'p-4',
        lg: 'p-6',
        xl: 'p-8'
      },
      lg: {
        default: 'p-6',
        lg: 'p-8',
        xl: 'p-10'
      },
      xl: {
        default: 'p-6',
        lg: 'p-8',
        xl: 'p-12'
      },
      '2xl': {
        default: 'p-8',
        lg: 'p-10',
        xl: 'p-14'
      }
    };

    return sizes[screenSize]?.[size] || sizes.lg[size];
  };

  return {
    isMobile,
    isTablet,
    typography,
    spacing,
    animationDuration,
    getTouchTargetSize,
    getResponsivePadding
  };
};